import type {Award,Card} from '@platform/contracts/x';
import {Button} from '@platform/ui/Button';
import {cardLabel} from '@platform/ui/cardLabel';
import {useCopy} from '@platform/ui/config';
import {CardBadge} from './CardBadge';
import './AwardCardBadges.css';

// Both result views use the confirmed award membership, including unsold ties.
export function AwardCardBadges({award,cards,onSelect}:{award:Award;cards:Card[];onSelect?:(id:string)=>void}){
 const t=useCopy(),own=new Set(award.ownCardIds),byId=new Map(cards.map(card=>[card.id,card]));
 const ids=[...new Set(award.cardIds)].sort((a,b)=>Number(own.has(b))-Number(own.has(a)));
 return <span className="award-card-badges" role="group" aria-label={t('award.winningCards',{count:ids.length})}>{ids.map(id=>{
  const card=byId.get(id),title=t(own.has(id)?'flow.ownWinningCard':'flow.otherWinningCard',{number:cardLabel(card??{id})});
  const badge=<CardBadge key={id} card={card??{id}} muted={!own.has(id)} title={title}/>;
  return onSelect?<Button key={id} className="award-card-link" aria-label={title} aria-haspopup="dialog" disabled={!card} onClick={()=>onSelect(id)}>{badge}</Button>:badge;
 })}</span>;
}
